import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { authFeature } from './state';
import { AuthSessionEffects, AuthStorageEffects } from './state/auth-session';
import { AuthPasswordEffects } from './state/auth-password';
import { AuthSsoEffects } from './state/auth-sso';
import { ImpersonationEffects } from './state/impersonation/impersonation.effects';

export const AUTH_STORE_PROVIDERS = {
  feature: provideState(authFeature),
  effects: provideEffects(
    AuthSessionEffects,
    AuthStorageEffects,
    AuthPasswordEffects,
    AuthSsoEffects,
    ImpersonationEffects,
  ),
};
